import _ from 'lodash';

export function productStatus(product: any, showRepeatType: boolean = true): string {
  if(!product) return '';
  let productStatus = product.status;
  if(productStatus == 'Open' && !!product.productState && product.productState != 'Active') {
    productStatus = productStatus + ` ${product.productState}`;
  }
  if(!product.repeatType || !showRepeatType) return productStatus;
  let modifiedCategoryList: string[] = [];
  if(product.status !== 'Confirmed') {
    const latestModifications = _.get(product,'modifications.0.modifications', []);
    modifiedCategoryList = _.map(_.keys(latestModifications), (category: string) => _.startCase(category));
  }
  if(modifiedCategoryList.length)  {
    return `${productStatus} (<span class="green--text">${product.repeatType}</span>: ${modifiedCategoryList.join(',')})`
  } else {
    return `${productStatus} (<span class="green--text">${product.repeatType}</span>)`;
  }
}